import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Cell, PaginationStyle } from "./styles";
import { PaginationQuery } from "../../types/query";
import { Skeleton } from "@mui/material";

type Props = {
  headers: { name: string }[];
  operations?: boolean;
  children: React.ReactNode[] | React.ReactNode;
  length: number;
  onPageQueryChange?: (query: PaginationQuery) => void;
  isLoading?: boolean;
};
export default function StickyTable({
  headers,
  onPageQueryChange,
  children,
  operations = false,
  length,
  isLoading = false,
}: Props) {
  const [query, setQuery] = React.useState<PaginationQuery>({
    page: 0,
    size: 10,
  });

  function handleQueryChange(query: PaginationQuery) {
    setQuery(query);
    if (onPageQueryChange) onPageQueryChange(query);
  }
  const hNumbers = headers.length + 1 + (operations ? 1 : 0);
  return (
    <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: "15px" }}>
      <TableContainer
        sx={{
          maxHeight: "70vh",
          overflow: "auto",
          minWidth: "40rem",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                  },
                }}
              >
                #
              </Cell>
              {headers?.map((header, index) => (
                <Cell
                  key={index}
                  sx={{
                    position: index === 0 ? "sticky !important" : "unset",
                    right: 0,
                    top: 0,
                    zIndex: 10,
                    bgcolor: "primary.main",
                  }}
                >
                  {header.name}
                </Cell>
              ))}
              {operations && (
                <Cell
                  sx={{
                    textAlign: "center !important",
                    "&.MuiTableCell-root": {
                      textAlign: "center !important",
                      color: "divider",
                    },
                  }}
                >
                  عملیات
                </Cell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading
              ? [1, 2].map((_) => (
                  <TableRow>
                    {Array.from({ length: hNumbers }).map((h) => (
                      <Cell>
                        <Skeleton
                          variant="rounded"
                          animation="wave"
                          width="auto"
                          height="revert-layer"
                        />
                      </Cell>
                    ))}
                  </TableRow>
                ))
              : children}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={length}
        rowsPerPage={query.size}
        labelRowsPerPage="تعداد ردیف های هر صفحه"
        page={query.page}
        sx={PaginationStyle}
        onPageChange={(event, page) => handleQueryChange({ ...query, page })}
        onRowsPerPageChange={(event) =>
          handleQueryChange({ ...query, size: Number(event.target.value) })
        }
      />
    </Paper>
  );
}
